export class SynchroniserEtatTransmissionEncaissementsResultat {
    constructor() {
        this.nbEncaissementsEnSucces = 0;
        this.nbEncaissementsNonTraites = 0;
        this.nbEncaissementsParametragesIntrouvables = 0;
        this.nbEncaissementsEnErreur = 0;
        this.encaissementsSynchroErreurTechnique = {};
    }

    public nbEncaissementsEnSucces: number;
    public nbEncaissementsNonTraites: number;
    public nbEncaissementsParametragesIntrouvables: number;
    public nbEncaissementsEnErreur: number;
    public encaissementsSynchroErreurTechnique: Record<string, string>;
}
